import Container from "hardcover-ui/components/Container";
import PageWrapper from "components/ui/PageWrapper";
import PageHeader from "components/shared/PageHeader";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import { upcomingLink } from "constants/ExploreLinks";
import TabsNavContainer from "components/shared/TabsNavContainer";
import TabLink from "hardcover-ui/components/TabLink";
import { usePage } from "@inertiajs/react";
import { UpcomingPageProps } from "./index.props";
import TrendingBooks from "components/trending/TrendingBooks";

function UpcomingBooks() {
  const { books } = usePage<UpcomingPageProps>().props;

  return (
    <PageWrapper>
      <Container variant="layout">
        <PageHeader
          icon={upcomingLink.iconDuo}
          title={upcomingLink.name}
          description={upcomingLink.description}
        />

        <div className="my-4">
          <TabsNavContainer>
            <TabLink href="/upcoming/recent" size="lg">
              <>Recent Releases</>
            </TabLink>
            <TabLink href="/upcoming/month" size="lg">
              <>1 Month</>
            </TabLink>
            <TabLink href="/upcoming/quarter" size="lg">
              <>3 Months</>
            </TabLink>
            <TabLink href="/upcoming/year" size="lg">
              <>1 Year</>
            </TabLink>
          </TabsNavContainer>
        </div>

        <div className="my-2">
          <TrendingBooks books={books} />
        </div>
      </Container>
    </PageWrapper>
  );
}

UpcomingBooks.layout = DefaultLayoutWrapper;
export default UpcomingBooks;